import { render, staticRenderFns } from "./RecipeSaveModal.vue?vue&type=template&id=5aac320e&slot=items&"
import script from "./RecipeSaveModal.script.js?vue&type=script&lang=js&"
export * from "./RecipeSaveModal.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports